import { useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useQueries, useQueryClient } from "react-query";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import { cleanObject, getRandomIntInclusive } from "../../../../helpers";
import {
  getAllChartOfAccounts,
  getMappingOfAccounts,
} from "../../../../services/accounting";
import { useUpdateAccountMappingMutation } from "../../../../hooks/api/mutations/useAccounting";

export const useAccountSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get("tab") || "sales_tab",
  );
  const updateAccountMappingMutation = useUpdateAccountMappingMutation();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const tableTabs = [
    {
      label: "Sales",
      key: "sales_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Expenses",
      key: "expenses_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Inventory",
      key: "inventory_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Taxes",
      key: "taxes_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Equity",
      key: "equity_tab",
      showOnLocalSetup: false,
    },
  ];

  const [allChartOfAccounts, mappingOfAccounts] = useQueries([
    {
      queryKey: ["getAllChartOfAccounts"],
      staleTime: Infinity,
      queryFn: () => getAllChartOfAccounts().then((res) => res?.data?.data),
    },
    {
      queryKey: ["getMappingOfAccounts"],
      staleTime: Infinity,
      queryFn: () => getMappingOfAccounts().then((res) => res?.data?.data),
    },
  ]);

  const handleAccountMappingSubmit = (data) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const formatedData = {
      accounts: Object.entries(data).map(([event_key, chart_account_id]) => ({
        event_key,
        chart_account_id,
      })),
    };
    updateAccountMappingMutation.mutate(cleanObject(formatedData), {
      onSuccess: (res) => {
        triggerToast(res?.data?.detail, "success");
        queryClient.invalidateQueries(["getMappingOfAccounts"]);
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  const filterAccountByAccountType = (accountType) => {
    return allChartOfAccounts?.data?.filter(
      (account) => account.account_type === accountType,
    );
  };

  const filterAccountBySubAccountType = (subAccountType) => {
    return allChartOfAccounts?.data?.filter(
      (account) => account.sub_account_type === subAccountType,
    );
  };

  const findAccountMapping = (eventKey) => {
    return mappingOfAccounts?.data?.find(
      (mapping) => mapping.event_key === eventKey,
    );
  };

  const updateSelectedTab = (key) => {
    setSelectedTab(key);
    searchParams.set("tab", key);
    setSearchParams(searchParams, { replace: true });
  };

  return {
    selectedTab,
    updateSelectedTab,
    tableTabs,
    isLoadingAccount:
      allChartOfAccounts.isLoading || mappingOfAccounts.isLoading,
    chartAccounts: allChartOfAccounts.data,
    accountMappings: mappingOfAccounts.data,
    updateAccountMappingMutation,
    filterAccountByAccountType,
    filterAccountBySubAccountType,
    findAccountMapping,
    handleAccountMappingSubmit,
  };
};
